import React from 'react';
import { Trans } from 'react-i18next';
import AppMessage from "./appMessage";
export default function apiError(props) {
    var _a;
    switch (props.errorType) {
        case "token_has_been_used":
            return (React.createElement(AppMessage, { success: false, element: React.createElement("p", null,
                    React.createElement(Trans, { i18nKey: "token_has_been_used" },
                        "Der Link zum Zur\u00FCcksetzen des Passworts wurde schon benutzt. Falls Sie Ihr Passwort noch einmal zur\u00FCcksetzen wollen, klicken Sie bitte ",
                        React.createElement("a", { href: "index.html" }, "hier"),
                        ".")) }));
        case "account_locked":
            return (React.createElement(AppMessage, { success: false, element: React.createElement("p", null,
                    React.createElement(Trans, { i18nKey: "account_locked" },
                        "Ihre LMU-Benutzerkennung ist gesperrt und es kann kein neues Passwort festgelegt werden. Bitte wenden Sie sich an den ",
                        React.createElement("a", { href: "https://www.it-servicedesk.uni-muenchen.de/kontakt/index.html" }, "IT-Servicedesk"),
                        ".")) }));
        case "user_context":
            return (React.createElement(AppMessage, { success: false, element: React.createElement("p", null,
                    React.createElement(Trans, { i18nKey: "user_context" },
                        "Der Link zum Zur\u00FCcksetzen des Passworts funktioniert nur mit dem ",
                        React.createElement("em", null, "selben"),
                        " Browser auf dem ",
                        React.createElement("em", null, "selben"),
                        " Ger\u00E4t, mit dem er angefordert wurde. Sie k\u00F6nnen den Vorgang ",
                        React.createElement("a", { href: "index.html" }, "hier"),
                        " noch einmal wiederholen.")) }));
        case "token_invalid":
            return (React.createElement(AppMessage, { success: false, element: React.createElement("p", null,
                    React.createElement(Trans, { i18nKey: "token_invalid" },
                        "Der Link zum Zur\u00FCcksetzen des Passworts ist nicht mehr g\u00FCltig. Sie k\u00F6nnen den Vorgang ",
                        React.createElement("a", { href: "index.html" }, "hier"),
                        " noch einmal wiederholen.")) }));
        case "email_confirmation_token_invalid":
            return (React.createElement(AppMessage, { success: false, element: React.createElement("p", null,
                    React.createElement(Trans, { i18nKey: "email_confirmation_token_invalid" },
                        "Der Link zum Best\u00E4tigen der E-Mail-Adresse ist nicht mehr g\u00FCltig. Sie k\u00F6nnen den Vorgang ",
                        React.createElement("a", { href: "https://www.portal.uni-muenchen.de/benutzerkonto/" }, "im Benutzerkonto"),
                        " noch einmal wiederholen.")) }));
        case "pw_not_equal":
            return (React.createElement(AppMessage, { message: "Die Passw\u00F6rter sind nicht gleich", success: false }));
        case "pw_policy":
            return (React.createElement(AppMessage, { message: "Das Passwort entspricht nicht den Richtlinien", success: false }));
        case "compromised_password":
            return (React.createElement(AppMessage, { message: "compromised_password", success: false }));
        default:
            return (React.createElement(AppMessage, { message: "" + ((_a = props.error) === null || _a === void 0 ? void 0 : _a.message), success: false }));
    }
}
